export const ZppCourseInfo = (data) => {
  let insuranceCompany = null;
  let courseTeaser = null;

  if (data.insuranceCompany) {
    insuranceCompany = {
      id: data.insuranceCompany.id || null,
      slug: data.insuranceCompany.slug || '',
      name: data.insuranceCompany.name || '',
      reductionRate: data.insuranceCompany.reductionRate || 0,
      supportEmail: data.insuranceCompany.supportEmail || ''
    };
  }
  if (data.courseTeaser) {
    courseTeaser = {
      backgroundColor: data.courseTeaser.backgroundColor || '',
      courseId: data.courseTeaser.courseId || null,
      id: data.courseTeaser.id || null,
      pictureV2: data.courseTeaser.pictureV2 || null,
      title: data.courseTeaser.title || ''
    };
  }

  return {
    bonusAccessStatus: data.bonusAccessStatus,
    completedAt: data.completedAt,
    courseId: data.courseId,
    courseStatus: data.courseStatus,
    courseTeaser,
    deadlineAt: data.deadlineAt,
    endsAt: data.endsAt,
    id: data.id,
    insuranceCompany,
    startedAt: data.startedAt,
    zppCourseAttendanceStatus: data.zppCourseAttendanceStatus
  };
};
